/**
 * @generated SignedSource<<0229a12fb2240397c6da1be678531105>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedAuctionInfo_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAuctionActionBinAndBid_viewer" | "PdpSharedAuctionActionCompletePurchase_viewer" | "PdpSharedAuctionSecondChanceOffer_viewer">;
  readonly " $fragmentType": "PdpSharedAuctionInfo_viewer";
};
export type PdpSharedAuctionInfo_viewer$key = {
  readonly " $data"?: PdpSharedAuctionInfo_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAuctionInfo_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAuctionInfo_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedAuctionActionBinAndBid_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedAuctionActionCompletePurchase_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedAuctionSecondChanceOffer_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "e604c722e87b17e0022f936000aef250";

export default node;
